/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createReducer, createAction } from '@reduxjs/toolkit';
import { bindActionCreators } from 'redux';
import { GetUserDataInterface, Subscription } from '@/types';

export interface OrderInitialState {
  subscription: Subscription;
}

export const initialState: OrderInitialState = {
  subscription: {} as Subscription,
};

const STORE_SUBSCRIPTION = 'STORE_SUBSCRIPTION';

export const getSubscriptionState: (state: any) => Subscription = (
  state: OrderInitialState
) => state.subscription;

export const storeSubscription = createAction(
  STORE_SUBSCRIPTION,
  (payload: Subscription) => ({
    payload: {
      ...payload,
    },
  })
);

export default createReducer(initialState, {
  [STORE_SUBSCRIPTION]: (state, action) => {
    state.subscription = action.payload;
  },
});
